import React from 'react';
import Affids from './components/Affids';

const Blocks = ({ blocks, onRemove }) => {
    const rows = Object.keys(blocks).map(feed => {
        return (
            <div>
                <h2>{feed}</h2>
                <Affids affids={blocks[feed]} onRemove={onRemove}/>
            </div>
        );
    });

    return (
        <div>
            {rows}
        </div>
    )
};

export default Blocks;


// WEBPACK FOOTER //
// ./src/scenes/BidderSourcesWhitelist/components/Blocks/index.js